import React, { useState } from "react";

import { CSwitch } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";

import URL from "../../config/api";
import axios from "../../config/axios";

/**
 * INTERRUPTOR DE LIBERAÇÃO DO RANKING para os alunos da turma.
 *
 * Mora junto do ranking — nas DUAS telas em que o professor vê a lista (o
 * modal aberto pela lista de turmas e a aba dentro da turma) — e não numa
 * tela de configuração à parte: quem decide se o aluno pode ver a lista quer
 * olhar a lista antes de decidir.
 *
 * O componente não guarda o valor: ele avisa o pai por `onChange` e o pai
 * manda no que está desenhado. É o que permite as duas telas compartilharem
 * este arquivo sem que uma delas fique com um estado paralelo ao da outra.
 *
 * A TROCA É OTIMISTA COM REVERSÃO: a chave vira no clique e volta sozinha se
 * a requisição falhar. Prender a chave até a resposta chegar faz parecer que
 * o clique não pegou.
 */
function InterruptorRanking({ roomId, checked, onChange, user }) {
  const [salvando, setSalvando] = useState(false);

  const alternar = () => {
    if (salvando) return;

    const novoValor = !checked;

    setSalvando(true);
    onChange(novoValor);

    axios
      .post(
        `${URL.api}gamification/ranking/visibility`,
        { room_id: roomId, visible: novoValor },
        { headers: { Authorization: `Bearer ${user.token}` } }
      )
      .then(() => {
        setSalvando(false);
        toastr.success(
          "Pronto",
          novoValor
            ? "O ranking agora aparece para os alunos desta turma."
            : "O ranking deixou de aparecer para os alunos desta turma."
        );
      })
      .catch(error => {
        setSalvando(false);
        onChange(!novoValor);
        toastr.error(
          "Erro",
          error.response?.data?.error ||
            "Não foi possível alterar a visualização do ranking."
        );
      });
  };

  return (
    <div className="d-flex align-items-center mb-3">
      <CSwitch
        shape="pill"
        size="sm"
        color="primary"
        className="mr-3"
        checked={checked}
        disabled={salvando}
        onChange={alternar}
      />
      <div>
        <div>Exibir o ranking para os alunos</div>
        <small className="text-muted">
          {checked
            ? "Os alunos desta turma veem a aba Ranking."
            : "Só você e a coordenação veem este ranking."}
        </small>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(InterruptorRanking);
